import dayjs from "dayjs";
import { auditReportTypeValues, constStr, customTasks, fileMgmtModuleList, rnLedActions, taskKeyProps } from "../../globals/constants";
import { IAddScheduledTask, IList, INodeFileMgmt, ISetDebug, ITaskDetails } from "../../store/api/tasks/types";
import { IKeyValue, IKeyValueAny } from "../Administrations/types";
import { IOption } from "../Shared/Filter/types";
import utc from "dayjs/plugin/utc";
import * as uuid from "uuid";
import { IGeoRegion } from "../../store/api/admin/types";
import { ISiteOfflineDetails } from "../../store/api/devices/types";

dayjs.extend(utc);

export const getDependencyTaskList = (data: ITaskDetails[]) => {
  let taskList: Array<string> = [];
  if (data?.length > 0) {
    taskList = data?.map((item: ITaskDetails) => item?.name);
  }
  return taskList;
};

export const enableNext = (scheduleData: IAddScheduledTask, activeStep: number, errorMsg: IKeyValue, selectionType?: string, groupList?: IList[]) => {
  let isEnable: boolean = false;
  if (activeStep === 0) {
    isEnable = !!scheduleData.taskName?.value;
  } else if (activeStep === 1) {
    if (selectionType?.toLowerCase() === "device") {
      isEnable = !!scheduleData?.deviceName && scheduleData?.deviceName.length > 0;
    } else if (selectionType?.toLowerCase() === "group") {
      isEnable = !!scheduleData?.siteGroupList && scheduleData?.siteGroupList.length > 0;
    } else if (selectionType?.toLowerCase() === "region") {
      isEnable = !!scheduleData?.regionList && scheduleData?.regionList.length > 0;
    }
  } else {
    if (scheduleData.taskName?.title === customTasks.reboot) {
      isEnable = true;
      //alert("you have not selected any option");
    }
    if (scheduleData.taskName?.title === customTasks.bulkConfiguration && !!scheduleData?.templateName) {
      isEnable = true;
    }
    if (scheduleData.taskName?.value.includes("softwareDownload")) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (scheduleData?.sshOperation) {
        isEnable =
          !!scheduleData.hostName &&
          !!scheduleData.fileName &&
          !!scheduleData.localFileName &&
          !!scheduleData.username &&
          !!scheduleData.sshKeyIndex &&
          errocount.length <= 0;
      } else {
        isEnable =
          !!scheduleData.hostName &&
          !!scheduleData.fileName &&
          !!scheduleData.localFileName &&
          !!scheduleData.username &&
          !!scheduleData.password &&
          errocount.length <= 0;
      }
    }
    if (scheduleData.taskName?.title === customTasks.radioNodeReplace) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.oldRadioNodeId && !!scheduleData?.newRadioNodeId && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.lteCell || scheduleData.taskName?.title === customTasks.nrCell) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (scheduleData?.cellIdSet) {
        isEnable = !!scheduleData?.cellAction && !!scheduleData?.cellIdValue && errocount.length <= 0;
      } else if (scheduleData?.zoneIdSet) {
        isEnable = !!scheduleData?.cellAction && !!scheduleData?.zoneIdValue && errocount.length <= 0;
      } else if (scheduleData?.allCell) {
        isEnable = !!scheduleData?.cellAction && errocount.length <= 0;
      } else {
        isEnable = false;
      }
    }
    if (scheduleData.taskName?.title === customTasks.snDbBackup) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      const isGenerateFile = scheduleData?.generateFileName ? true : false;
      isEnable = (!!scheduleData?.fileName?.trim() || !!scheduleData?.prefixFileName?.trim() || isGenerateFile) && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.snDbRestore) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.fileName?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.softwareUpdate) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.updatePackage?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.radioNodeOperations) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (!scheduleData?.actionName || scheduleData?.actionName === rnLedActions[0]) {
        isEnable = !!scheduleData?.radioNodeId?.trim() && errocount.length <= 0;
      }
      if (scheduleData?.actionName === rnLedActions[1]) {
        isEnable = !!scheduleData?.followIMSI?.trim() && errocount.length <= 0;
      }
      if (scheduleData?.actionName === rnLedActions[2]) {
        isEnable = true;
      }
    }
    if (scheduleData.taskName?.title === customTasks.exportSnDataModel) {
      //const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = true; //!!scheduleData?.outputDirectory?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.setDebug) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (!!scheduleData?.setDebugRows && scheduleData?.setDebugRows?.length > 0) {
        const isEmptyArray = scheduleData.setDebugRows?.map((item: ISetDebug) => Object.values(item).includes("-"));
        isEnable = !!scheduleData?.setDebug?.trim() && !isEmptyArray.includes(true) && errocount.length <= 0;
      } else {
        isEnable = !!scheduleData?.setDebug?.trim() && errocount.length <= 0;
      }
    }
    if (scheduleData.taskName?.title === customTasks.lciSetPassword) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.password?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.setPassword) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.password?.trim() && !!scheduleData?.newPassword?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.radiounitTroubleshooting) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.radiounitId?.trim() && !!scheduleData?.radiounitLogRequest?.trim() && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.lteRnLocation) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (scheduleData.lteRnLocationRequest === constStr.checkLocation) {
        if (scheduleData?.isAll) {
          isEnable = scheduleData?.isAll && errocount.length <= 0;
        } else {
          isEnable = (!!scheduleData?.radioNodeId || !!scheduleData?.zoneIdValue) && errocount.length <= 0;
        }
      } else if (scheduleData.lteRnLocationRequest === constStr.createBaseline) {
        isEnable = !!scheduleData?.radioNodeId && errocount.length <= 0;
      } else {
        isEnable = errocount.length <= 0;
      }
    }
    if (scheduleData.taskName?.title === customTasks.lteSelfConfig) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      if (scheduleData.lteSelfConfigType === constStr.neighborList) {
        isEnable = true;
      } else if (scheduleData.lteSelfConfigType !== constStr.neighborList && scheduleData.txPowerType === "Max Power") {
        if (scheduleData.allString === "ALL") {
          isEnable = true;
        } else {
          isEnable = !!scheduleData.zoneIdValue && errocount.length <= 0;
        }
      } else if (scheduleData.lteSelfConfigType !== constStr.neighborList && scheduleData.txPowerType === "REM Based") {
        isEnable =
          (!!scheduleData?.neighborToCover ||
            !!scheduleData?.maxSwing ||
            !!scheduleData.targetRSRP ||
            !!scheduleData?.targetSIR ||
            !!scheduleData?.nominalPLHigh ||
            !!scheduleData?.nominalPLLow ||
            !!scheduleData?.zoneRemValue) &&
          errocount.length <= 0;
      }
    }
    if (scheduleData.taskName?.title === customTasks.fileManagementCreate) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = !!scheduleData?.nodeFileMgmt && scheduleData?.nodeFileMgmt?.length > 0 && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.testSnmpTrap) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = scheduleData.trapTarget !== undefined && scheduleData?.trapTarget >= 0 && errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.lteRemStart) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable = errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.auditReports) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      isEnable =
        scheduleData.auditReportType !== auditReportTypeValues.none &&
        !!scheduleData.emailGroupName &&
        errocount.length <= 0;
    }
    if (scheduleData.taskName?.title === customTasks.customAuditReport) {
      const errocount = Object.values(errorMsg).filter((item) => Boolean(item));
      const mode = scheduleData.customReportInputMode || "TEMPLATE";
      if (mode === "TEMPLATE") {
        isEnable = !!scheduleData.templateName && errocount.length <= 0;
      } else if (mode === "UPLOAD") {
        isEnable = !!scheduleData.templateName && errocount.length <= 0;
      } else {
        isEnable = !!scheduleData.manualAttributes?.trim() && errocount.length <= 0;
      }
    }
  }
  return isEnable;
};

 export const enableSiteNext = (formData: ISiteOfflineDetails, activeStep: number) => {
  let isEnable: boolean = false;
  if(activeStep === 0) {
      isEnable = !!(formData?.serialNumber)

  }
  return isEnable;
}

export const getInputKeyByCheckBoxKey = (word: string) => {
  const first2 = word.substring(2, word.length);
  const newkey = first2.charAt(0).toLowerCase() + first2.substring(1);
  return newkey;
};

export const taskCommanPayload = (taskFormData: IAddScheduledTask, selectionType: string, groupList: IList[], selectedGeoRegion: IGeoRegion) => {
  let devices: IKeyValueAny = {};
  let deviceType = selectionType.charAt(0).toUpperCase()+selectionType.slice(1)?.toLowerCase() || "";
  selectionType === "DEVICE" && taskFormData.deviceName?.forEach((item: IOption, index: number) => {
    devices[`DEVICES${index}`] = item.value;
  });
  if(selectionType === "DEVICE") {
    devices['EXECUTION_TARGET'] = deviceType;
    devices['EXECUTION_TARGET_NAME'] = "";
  }
  if(selectionType === "GROUP") {
    devices['EXECUTION_TARGET'] = deviceType;
    devices['EXECUTION_TARGET_NAME'] = taskFormData.siteGroupList?.map(el => el?.value)?.join(',') || [];
  }
  if(selectionType === "REGION") {
    devices['EXECUTION_TARGET'] = deviceType;
    const selectedRegions = taskFormData.regionList || [];
    devices['EXECUTION_TARGET_NAME'] = selectedRegions.map(el => el?.value)?.join(',') || "";
  }
  if (!!taskFormData.parentTask && taskFormData.parentTask !== "None") {
    devices = { ...devices, parentTask: taskFormData.parentTask };
  }
  const currentTimeInMil = !!taskFormData.nextTime ? taskFormData.nextTime : dayjs().valueOf();
  let selectedTaskName: string = taskFormData?.taskName?.value || "";
  if (selectedTaskName === "lteCell" || selectedTaskName === "nrCell") {
    selectedTaskName = `${selectedTaskName}${taskFormData.cellAction}`;
  }
  return {
    geoRegion: taskFormData.geoRegion,
    name: taskFormData.name,
    description: taskFormData.description,
    domainKey: "Initial Domain", // NIMS-1214: Remove Domains from tasks UI
    scheduleOnce: Number(taskFormData.period) === 0 ? 1 : 0,
    nextTime: currentTimeInMil?.toString(), //start At
    period: taskFormData.period, //Repeats
    className: selectedTaskName,
    ...(["Database Backup", "Database Integrity", "NodeDmBackupTask", "NodeDbBackupTask"]?.includes(taskFormData.name || "")
      ? { taskProperties: {} }
      : {
          taskProperties: {
            PARAMETER_SET: false, // this is not cleared to map with which GUI Input field.
            encryptPasswords: false, // this is not cleared to map with which GUI Input field.
            tasksMaxConcurrentDevices: taskFormData.tasksMaxConcurrentDevices,
            //parentTask: taskFormData.parentTask !== "None" ? taskFormData.parentTask : "", // Dependency task
            ...devices,
          },
        }),
  };
};

export const getNewDeviceList = (deviceList: IList[], selectedList: IList[]) => {
  const filteredDeviceList = deviceList.filter(
    (device) => !selectedList.some((selected) => selected.title === device.title && selected.value === device.value)
  );

  return filteredDeviceList;
};

export const prepareTaskPayload = (taskFormData: any, selectionType: string, groupList: IList[], selectedGeoRegion: IGeoRegion, username: string) => {

  const taskPayload = taskCommanPayload(taskFormData, selectionType, groupList, selectedGeoRegion);
  let taskPropArray: IKeyValueAny = {};
  const taskKeyProperties = taskFormData.taskName?.value ? taskKeyProps[taskFormData.taskName?.value] : "";
  if (!!taskKeyProperties && Object.keys(taskKeyProperties).length > 0) {
    Object.entries(taskKeyProperties).forEach(([key, value]) => {
      if (value?.toLowerCase() === "creator") {
        taskPropArray = { ...taskPropArray, [value]: username || "" };
      } else taskPropArray = { ...taskPropArray, [value]: taskFormData[key] };
    });
  }
  return {
    ...taskPayload,
    ...(["Database Backup", "Database Integrity", "NodeDmBackupTask", "NodeDbBackupTask"]?.includes(taskFormData?.name || "")
      ? { taskProperties: {} }
      : {
          taskProperties: {
            ...taskPayload.taskProperties,
            ...taskPropArray,
          },
        }),
  };
};

export const setDebugArrayToSting = (data: ISetDebug[]) => {
  let setDebugStr: string = "";
  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      if (!data[i].isNew) {
        if (setDebugStr.length <= 0) {
          setDebugStr = `${data[i].module},${data[i].group},${data[i].level},${data[i].nodeId}`;
        } else {
          setDebugStr = `${setDebugStr}|${data[i].module},${data[i].group},${data[i].level},${data[i].nodeId}`;
        }
      }
    }
  }
  return setDebugStr;
};

export const resetSelfConfig = {
  zoneIdValue: "",
  allString: "",
  neighborToCover: "",
  maxSwing: "",
  targetRSRP: "",
  targetSIR: "",
  nominalPLHigh: "",
  zoneRemValue: "",
  nominalPLLow: "",
};

export let nodeFileMgmtDefault = {
  id: uuid.v4(),
  moduleId: fileMgmtModuleList[3].value,
  maxAttemptDuration: 0,
  maxAttempts: 0,
  randomUploadMaxDelay: 0,
  hostName: "",
  username: "",
  password: "",
  generateSCOSSSHKey: false,
  autoPopulatedAuthorizedKeyFile: false,
  forwordingGroupIndex: 0,
  overwriteMode: "Overwrite",
  priority: "Primary",
  protocol: "FTP",
  remotePath: "",
  remotePermission: "rw-r--r--",
};

export const prepareDataForNodeFileMgmt = (stringData: string, passwordStr: string) => {
  let nodeFileMgmtArray: INodeFileMgmt[] = [];
  if (stringData.length > 0) {
    let nodeFileMgmtObj: INodeFileMgmt;
    const rowArray = stringData.split("|");
    const passArray = passwordStr?.includes("|") ? passwordStr?.split("|") : [passwordStr];

    rowArray.length > 0 &&
      rowArray.forEach((cellString: string, index: number) => {
        const strCellArray = cellString.split(",");
        if (strCellArray.length > 0) {
          nodeFileMgmtObj = {
            id: uuid.v4(),
            moduleId: strCellArray[0],
            maxAttemptDuration: Number(strCellArray[1]),
            maxAttempts: Number(strCellArray[2]),
            randomUploadMaxDelay: Number(strCellArray[3]),
            hostName: strCellArray[4],
            username: strCellArray[5],
            password: passArray[index],
            generateSCOSSSHKey: strCellArray[6] === "true",
            autoPopulatedAuthorizedKeyFile: strCellArray[7] === "true",
            forwordingGroupIndex: Number(strCellArray[8]),
            overwriteMode: strCellArray[9],
            priority: strCellArray[10],
            protocol: strCellArray[11],
            remotePath: strCellArray[12],
            remotePermission: strCellArray[13],
          };
        }
        nodeFileMgmtArray.push(nodeFileMgmtObj);
      });
  }
  return nodeFileMgmtArray;
};

export const getNewOptions = (optionList: IList[], selectedList: IList[]) => {
  const filteredOptionList = optionList.filter(
    (device) => !selectedList.some((selected) => selected.title === device.title && selected.value === device.value)
  );

  return filteredOptionList;
};
